import { useEffect } from 'react';
import { Hero, SocialProof, Testimonials1, Problem } from './components/HeaderSections';
import { ProductTomos, Bonuses, UrgencyCounter, Pricing } from './components/CoreSections';
import { Testimonials2, Guarantee, FAQ, CostOfNotHaving, FinalCTA, Footer } from './components/FooterSections';
import { SocialProofPopup } from './components/SocialProofPopup';
import { ExitIntentModal } from './components/ExitIntentModal';
import { MetaPixel } from './components/MetaPixel';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/agacHF4oUprc8XhkQK75E2/mockup_sticker.png';
const CHECKOUT_ORIGIN = 'https://megapack-colorimetria.impultienda.ar';
// Helper: ensure a <meta> tag with given attributes exists in <head>
const ensureMeta = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = Object.entries(attrs).filter(([k]) => k !== 'content').map(([k, v]) => `[${k}="${v}"]`).join('');
  let meta = document.head.querySelector<HTMLMetaElement>(`meta${selector}`);
  if (!meta) {
    meta = document.createElement('meta');
    document.head.appendChild(meta);
  }
  Object.entries(attrs).forEach(([k, v]) => meta!.setAttribute(k, v));
};
// Helper: ensure a <link> tag exists in <head>
const ensureLink = (attrs: Record<string, string>) => {
  if (typeof document === 'undefined') return;
  const selector = `link[rel="${attrs.rel}"][href="${attrs.href}"]`;
  if (document.head.querySelector(selector)) return;
  const link = document.createElement('link');
  Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v));
  document.head.appendChild(link);
};
export function App() {
  useEffect(() => {
    if (typeof document === 'undefined') return;
    // Language + translation blocking (Spanish - Latin America)
    document.documentElement.lang = 'es-419';
    document.documentElement.setAttribute('translate', 'no');
    document.title = 'MEGAPACK COLORIMETRÍA LISTA';
    ensureMeta({
      'http-equiv': 'content-language',
      content: 'es-419'
    });
    ensureMeta({
      name: 'google',
      content: 'notranslate'
    });
    ensureMeta({
      name: 'language',
      content: 'Spanish'
    });
    ensureMeta({
      name: 'description',
      content: 'Megapack Colorimetría Lista: 15 módulos en video, 4 manuales PDF (475+ páginas) y 5 bonos imprimibles. El sistema completo de colorimetría masculina por 24 USD. Pagas en tu moneda local.'
    });
    ensureMeta({
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, viewport-fit=cover'
    });
    ensureMeta({
      name: 'theme-color',
      content: '#0A0908'
    });
    // Social preview
    ensureMeta({
      property: 'og:title',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      property: 'og:site_name',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      name: 'twitter:title',
      content: 'MEGAPACK COLORIMETRÍA LISTA'
    });
    ensureMeta({
      property: 'og:description',
      content: '15 Módulos en video · 4 Manuales · 5 Bonos imprimibles. TODO organizado para dominar la colorimetría masculina.'
    });
    ensureMeta({
      property: 'og:image',
      content: HERO_IMAGE
    });
    ensureMeta({
      property: 'og:type',
      content: 'product'
    });
    ensureMeta({
      name: 'twitter:card',
      content: 'summary_large_image'
    });
    // Performance: preconnect to Google Fonts (faster font load)
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.googleapis.com'
    });
    ensureLink({
      rel: 'preconnect',
      href: 'https://fonts.gstatic.com',
      crossorigin: ''
    });
    // Performance: preconnect to the CDN serving the hero mockup + bonus covers
    ensureLink({
      rel: 'preconnect',
      href: 'https://cdn.magicpatterns.com'
    });
    ensureLink({
      rel: 'preload',
      as: 'image',
      href: HERO_IMAGE,
      fetchpriority: 'high'
    });
    // Performance: warm up the checkout connection so CTA clicks navigate
    // instantly. TCP + TLS happens in the background while the user reads.
    ensureLink({
      rel: 'dns-prefetch',
      href: CHECKOUT_ORIGIN
    });
    ensureLink({
      rel: 'preconnect',
      href: CHECKOUT_ORIGIN,
      crossorigin: ''
    });
    // Performance: resolve the pixel host early without blocking the paint
    ensureLink({
      rel: 'dns-prefetch',
      href: 'https://connect.facebook.net'
    });
  }, []);
  return <div lang="es-419" translate="no" className="min-h-screen bg-bg-base font-sans text-txt-body selection:bg-brandGold selection:text-[#14100A] notranslate" data-id="element-0" data-mp="c9u55xmbh6aw">
      <MetaPixel data-id="element-1" data-mp="14xyect43k1ic" />
      <SocialProofPopup data-id="element-2" data-mp="14xg7l2jt64w6" />
      <ExitIntentModal data-id="element-3" data-mp="14v3tj0h68eoe" />
      <main data-id="element-4" data-mp="zxk73dabkvld">
        <Hero data-id="element-5" data-mp="zx29ac80e9bc" />
        <SocialProof data-id="element-6" data-mp="zwis4xq6noyd" />
        <Testimonials1 data-id="element-7" data-mp="zw0ohg16y8gf" />
        <Problem data-id="element-8" data-mp="vw8nboe4n4l3" />
        <ProductTomos data-id="element-9" data-mp="vwrty8ybu6jt" />
        <Bonuses data-id="element-10" data-mp="vv70ynrnuvo2" />
        <UrgencyCounter data-id="element-11" data-mp="vvp1hwlcvw1s" />
        <Pricing data-id="element-12" data-mp="vyl0zpcuqssc" />
        <Testimonials2 data-id="element-13" data-mp="3knt1j0d7atox" />
        <Guarantee data-id="element-14" data-mp="3kob2ubepzy3p" />
        <FAQ data-id="element-15" data-mp="3kpm8kgrq7fxg" />
        <CostOfNotHaving data-id="element-16" data-mp="3kpdwgr3fgenb" />
        <FinalCTA data-id="element-17" data-mp="3gmh96n2xzud1" />
      </main>
      <Footer data-id="element-18" data-mp="3gm7p1g4kwhf9" />
    </div>;
}